import config from '../components/common/Config';

function accessTokenMeansBws(raw) {
  return String(raw ?? '').trim().toLowerCase() === 'tes';
}

export function isBritWholesaleUi() {
  const prefixMatch = config.PREFIX === 'tes';
  const raw =
    typeof localStorage === 'undefined' ? null : localStorage.getItem('accessToken');
  const tokenMatch = accessTokenMeansBws(raw);
  const result = prefixMatch || tokenMatch;

  if (
    typeof process !== 'undefined' &&
    process.env.NODE_ENV === 'development' &&
    typeof window !== 'undefined' &&
    window.sessionStorage?.getItem('debugBritWs') === '1'
  ) {
    console.info('[britWholesaleUi]', {
      PREFIX: config.PREFIX,
      accessTokenRaw: raw,
      prefixMatch,
      tokenMatch,
      result,
    });
  }

  return result;
}
